export enum Statuses {
  Open = "ai.workflows.statuses.open",
  InReview = "ai.workflows.statuses.inReview",
  Closed = "ai.workflows.statuses.closed",
  Draft = "ai.workflows.statuses.draft",
}
